import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemBack: {
		id: 'spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back',
		defaultMessage: 'Back to project',
		description: '"Back" menu item.',
	},
});
